<div class="row col-12 mx-0 mt-3 pt-2 pb-3" style="background-color:#dcdcdc">
    <div class="col-4"></div>
    <div class="col-auto">
        {{'PROBLEM_CALL_FOOTER_1'|translate}}<br>
        <h4 class="text-black">{{'PROBLEM_CALL_FOOTER_2'|translate}}</h4>
    </div>
    <div class="col-auto">
        <h1 style="color:#024463">1355<img src="assets/img/iconCallCenter.png" alt="logo"></h1>
    </div>
    <div class="col"></div>
</div>